module.exports = __webpack_public_path__ + "static/media/1POLICY4.cbfe6bf2.jpg";